import styled, { css } from 'styled-components';
import breakpoint, { sizes } from '../../../utils/style-utils';

type WrapperProps = {
	hasRegulationsHeader?: boolean;
	hasNativeHeaders?: boolean;
};

const Wrapper = styled.div<WrapperProps>`
	min-height: ${({ hasRegulationsHeader, hasNativeHeaders: thisHasNativeHeaders }) => `calc(
			100vh -
				${
					hasRegulationsHeader
						? `calc(var(--regulationHeight) + var(--smallerHeaderHeight))`
						: thisHasNativeHeaders
							? '0'
							: 'var(--smallerHeaderHeight)'
				}
		)`};

	@media (min-width: ${sizes.lg}px) {
		min-height: ${({ hasRegulationsHeader }) => `calc(
			100vh -
				${
					hasRegulationsHeader
						? `var(--headerHeight) + var(--subHeaderHeight) + var(--regulationHeight)`
						: `var(--headerHeight) + var(--subHeaderHeight)`
				}
		)`};
	}

	background-color: var(--sportsbook-root-bg-color, rgba(var(--base-09), 1));
`;

const Layout = styled.section<{ hasGlobalNav: boolean }>`
	display: flex;
	justify-content: center;
	gap: 20px;
	max-width: 1510px;
	margin: 0 auto;
	width: 100%;

	${({ hasGlobalNav }) =>
		hasGlobalNav &&
		css`
			padding: 12px 0 0 0;
		`}

	${breakpoint.lg`
		padding: 20px;
	`}
`;

const ContentWrapper = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	flex: 3; /* Ensures content takes more space than the sidebar */
	width: auto;
	margin: 0 auto;

	${breakpoint.lg`
		align-items: flex-start;
		margin: 0;
		gap: 20px;
	`}
`;

export { Wrapper, Layout, ContentWrapper };
